import { useState, type FormEvent } from "react";
import { errorMessage } from "./errorMessage";

export type TotpPolicy = "off" | "admin" | "all";

// 세 값의 뜻. 서버의 CHECK 와 같다 — 네 번째를 지어내지 않는다.
export const TOTP_POLICIES: { value: TotpPolicy; label: string; desc: string }[] = [
  { value: "off", label: "강제하지 않음", desc: "원하는 사람만 등록합니다. 기본값입니다." },
  { value: "admin", label: "관리자만 필수", desc: "관리자 계정은 등록 전까지 관리 화면·API 를 쓸 수 없습니다." },
  { value: "all", label: "전원 필수", desc: "모든 계정이 로그인 직후 등록 화면으로 갑니다." },
];

export interface TotpPolicyFormProps {
  // 지금 저장된 값. 바뀌면 부르는 쪽이 다시 넘긴다.
  saved: TotpPolicy;
  onSave: (policy: TotpPolicy) => Promise<void>;
  // 설명 아래 한 줄 더(예: IdP 는 「SSO 로 붙는 서비스 전부에 적용된다」).
  note?: string;
}

// 강제 정책 라디오 세 줄 + 저장. 틀(.card·제목)은 부르는 쪽 것이다.
export function TotpPolicyForm({ saved, onSave, note }: TotpPolicyFormProps) {
  const [policy, setPolicy] = useState<TotpPolicy>(saved);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await onSave(policy);
    } catch (err) {
      setError(errorMessage(err, "저장하지 못했습니다. 다시 시도해 주세요."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="mtotp" onSubmit={submit}>
      <p className="mtotp-note">
        2단계 인증은 OTP 앱(RFC 6238)의 6자리 코드를 비밀번호 뒤에 한 번 더 묻는 방식입니다.
        {note ? " " + note : ""}
      </p>
      <div className="mtotp-policy">
        {TOTP_POLICIES.map((p) => (
          <label className="mtotp-policy__row" key={p.value}>
            <input
              type="radio"
              name="totp-policy"
              value={p.value}
              checked={policy === p.value}
              onChange={() => setPolicy(p.value)}
              disabled={busy}
            />
            <span>
              <strong>{p.label}</strong>
              {saved === p.value && <span className="b-badge b-badge-info mtotp-policy__now">지금</span>}
              <br />
              <span className="mtotp-note">{p.desc}</span>
            </span>
          </label>
        ))}
      </div>
      {error && (
        <div className="b-toast b-toast-danger mtotp-toast" role="alert">
          <div className="b-toast-text">
            <div className="b-toast-body">{error}</div>
          </div>
        </div>
      )}
      <div className="mtotp-actions">
        <button className="b-btn b-btn-primary b-btn-lg" type="submit" disabled={busy || policy === saved}>
          {busy ? "저장하는 중…" : "정책 저장"}
        </button>
      </div>
    </form>
  );
}
